import React, { useState,useEffect,useRef }  from 'react';
import { Button, Dropdown, Space, Tag,Popconfirm,Switch, message  } from 'antd';
import { EllipsisOutlined, PlusOutlined,EyeOutlined,EyeInvisibleOutlined,EditOutlined,DeleteOutlined } from '@ant-design/icons';
import { ProTable, TableDropdown } from '@ant-design/pro-components';
import EditModel from './components/edit';
import {getApiData} from "../../../request/api";
import checkLogin from '../../../request/checkLogin.js'

export const waitTimePromise = async (time) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export const waitTime = async (time) => {
  await waitTimePromise(time);
};

// type GithubIssueItem = {
//   url: string;
//   id: number;
//   number: number;
//   title: string;
//   labels: {
//     name: string;
//     color: string;
//   }[];
//   state: string;
//   comments: number;
//   created_at: string;
//   updated_at: string;
//   closed_at?: string;
// };
// "cid": "分类ID",
// "ctime": "创建时间",
// "name": "分类名称",
// "pid": "父级ID",
// "key": "关键字/编号",
// "status": "状态 0：隐藏 1：正常",
// "level": "等级 0：父级 1：一级 2：二级"
var tableData = [
  {
    "cid": "1731",
    "name": "admin",
    "group": "超级管理员",
    "logintime": "2023-11-01 15:00:23",
    "status": "1",
  },
  {
    "cid": "1731",
    "name": "张三",
    "group": "奖项组长",
    "logintime": "2023-11-01 15:00:23",
    "status": "1",
  },

]

export default () => {
  const actionRef = useRef();

  const [showModal, setShowModal] = useState(false);
  const [rowInfo, setRowInfo] = useState({});
  const [catList, setCatList] = useState([]);

  const closeModal = () =>{
    setShowModal(false);
  }

  const onChangeStatus = (cid, checked) =>{
    console.log(cid,checked)
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      search:false,
      // valueType: 'indexBorder',
      // width: 100,
      ellipsis: true,
    },
    {
      title: '用户名',
      dataIndex: 'account',
      search:false,
      // valueType: 'indexBorder',
      // width: 100,
      ellipsis: true,
    },
    {
      title: '所属组别',
      dataIndex: 'rolegroup',
      // ellipsis: true,
      // render: (text, record) => {
      //   return <span style={{marginLeft:record.sep?6:0}}>{record.sep}{text}</span>;
      // },

      // copyable: true,
      // tip: '标题过长会自动收缩',
      // formItemProps: {
      //   rules: [
      //     {
      //       required: true,
      //       message: '此项为必填项',
      //     },
      //   ],
      // },
    },
    {
      disable: true,
      title: '状态',
      dataIndex: 'status',
      width: 100,
      // filters: true,
      // onFilter: true,
      // ellipsis: true,
      // valueType: 'select',
      valueEnum: {
        "0": {
          text: '禁用',
          status: 'Default',
        },
        "1": {
          text: '正常',
          status: 'Success',
          // disabled: true,
        },
      },
      // render: (text, record) => {
      //   console.log('status----------',text,record)
      //   return <Switch defaultChecked={text=="1"?true:false} size="small" onChange={(checked)=>onChangeStatus(record.cid, checked)} />;
      // },

    },
    {
      title: '最后登录',
      dataIndex: 'lastvisit',
      search:false,
      // valueType: 'indexBorder',
      // width: 100,
      ellipsis: true,
    },
    {
      title: '操作',
      valueType: 'option',
      width: 80,
      key: 'option',
      render: (text, record, _, action) => [
        <a
          key="editable"
          onClick={async() => {
            console.log('record ------------- ', record)
            console.log('action ------------- ', action)
            // action?.startEditable?.(record.id);
            setRowInfo(record);
            await waitTime(100);
            setShowModal(true);
          }}
        >
          <EditOutlined style={{backgroundColor:"rgb(24,188,156)",padding:"2px 3px",borderRadius:3,color:"white"}} />
        </a>,
        <Popconfirm title="确定删除吗?" onConfirm={() => delRow(record.uid)}>
          <DeleteOutlined style={{backgroundColor:"#ff4d4f",padding:"2px 3px",borderRadius:3,color:"white"}} />
        </Popconfirm>
      ],
    },
  ];

  // 删除管理员
  const delRow = (id) => {
    if(!id)
      return ;
      
    try {
      getApiData('A', 'A_delAdmin', {userid:id}).then((res) => {
        console.log('A_delAdmin-res-----------------', res);
        var flag = checkLogin('A', res.data)
        if (flag) {
          message.success("操作成功");
          actionRef.current.reload();
        }
      });
      } catch (error) {
        
      }
  };

  return (
    <div>
          
    <ProTable
      headerTitle="账号管理"
      rowKey="id"
      columns={columns}
      actionRef={actionRef}
      cardBordered
      defaultSize="small"
      request={async (params, sort, filter) => {
        console.log('params, sort, filter -------------------- ');
        console.log(params);
        console.log(sort);
        console.log(filter);
        var tableData = [];
        try {
          await getApiData('A', 'A_adminList', params).then((res) => {
            console.log('A_adminList-res-----------------', res);
            var flag = checkLogin('A', res.data)
            if (flag) {
              tableData = res.data.d.list;
            }
          });
        } catch (error) {
          
          // return false;
        }
        return {
          data: tableData,
          // current: res.data.pageNo,
          // pageSize: res.data.pageSize,
          success: true,
          // total: res.data.totalRows,
        };
      }}
      // editable={{
      //   type: 'multiple',
      // }}
      // columnsState={{
      //   persistenceKey: 'pro-table-singe-demos',
      //   persistenceType: 'localStorage',
      //   onChange(value) {
      //     console.log('value: ', value);
      //   },
      // }}
      search = {false}
      // search={{
      //   labelWidth: 'auto',
      // }}
      // options={{
      //   setting: {
      //     listsHeight: 200,
      //   },
      // }}
      // form={{
      //   // 由于配置了 transform，提交的参与与定义的不同这里需要转化一下
      //   syncToUrl: (values, type) => {
      //     if (type === 'get') {
      //       return {
      //         ...values,
      //         created_at: [values.startTime, values.endTime],
      //       };
      //     }
      //     return values;
      //   },
      // }}
      pagination={false}
      // pagination={{
      //   pageSize: 5,
      //   onChange: (page) => console.log(page),
      // }}
      // dateFormatter="string"
      // rowSelection={{
      //   // 自定义选择项参考: https://ant.design/components/table-cn/#components-table-demo-row-selection-custom
      //   // 注释该行则默认不显示下拉选项
      //   // selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
      //   defaultSelectedRowKeys: [],
      // }}
      // tableAlertRender={({
      //   selectedRowKeys,
      //   selectedRows,
      //   onCleanSelected,
      // }) => {
      //   console.log(selectedRowKeys, selectedRows);
      //   return (
      //     <Space size={24}>
      //       <span>
      //         已选 {selectedRowKeys.length} 项
      //         <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
      //           取消选择
      //         </a>
      //       </span>
      //       {/* <span>{`容器数量: ${selectedRows.reduce(
      //         (pre, item) => pre + item.containers,
      //         0,
      //       )} 个`}</span>
      //       <span>{`调用量: ${selectedRows.reduce(
      //         (pre, item) => pre + item.callNumber,
      //         0,
      //       )} 次`}</span> */}
      //     </Space>
      //   );
      // }}
      // tableAlertOptionRender={() => {
      //   return (
      //     <Space size={16}>
      //       <a><EyeOutlined />设为正常</a>
      //       <a><EyeInvisibleOutlined />设为隐藏</a>
      //     </Space>
      //   );
      // }}
      toolBarRender={() => [
        <Button
          key="button"
          icon={<PlusOutlined />}
          style={{backgroundColor:"rgb(5,168,137)"}}
          onClick={async() => {
            // actionRef.current?.reload();
            setRowInfo({});
            await waitTime(100);
            setShowModal(true)
          }}
          type="primary"
        >
          新建
        </Button>,
      ]}
    />


    <EditModel
      showModal={showModal}
      closeModal={closeModal}
      rowInfo={rowInfo}
      catList={catList}
      refreshlist={()=>{actionRef.current?.reload();}}
    />

    </div>
  );
};